export const ExperimentType = {
    // "ACTIVATION_FLOW": "1",
    "REFERRAL_SMS": "2",
    "PREORDER": "3",
    // "GO_TO_MENU": "4"
    // "ACTIVATION_ROOM_SERVICE": "5",
    "HAPPY_HOUR": "6",
    "ON_PREM": "7",
    "PRIVATE_CHEF": "8",
    "MULTIPLE_EVENT_TIMES": "9",
    // "REEF_DTC": "10",
    // "REEF_SLOT_SELECTION": "11"
}